var $ = window.jQuery; // TODO: require("jquery");

var DOM = {
    TAC_CHECKBOX: '.js-tac',
    TAC_DENIAL: '.js-tac_denial',
    SUBMIT_BUTTON: '.js-tac_update'
};

var __initialSubmitLink = null;

var grepInitialSubmitLink = function () {
    if (!__initialSubmitLink) {
        __initialSubmitLink = $(DOM.SUBMIT_BUTTON).attr('href');
    }
};

$(document).ready(function($) {
    $(document).on('change', DOM.TAC_CHECKBOX, function() {
        grepInitialSubmitLink();

        var $submitButton = $(DOM.SUBMIT_BUTTON);
        var $checkbox = $(DOM.TAC_CHECKBOX);
        var $denial = $(DOM.TAC_DENIAL);
        var isChecked = $checkbox.is(":checked");

        if(isChecked) {
            $denial.addClass("invisible");
            $submitButton.removeClass("btn--disabled");
            $checkbox.removeClass("checkbox--error")
        } else {
            $denial.removeClass("invisible");
            $submitButton.addClass("btn--disabled");
            $checkbox.addClass("checkbox--error")
        }

        // IMPORTANT!!! href replacement only works when url already has a parameter!!! ('bla?xxx')
        var new_link = ('' + __initialSubmitLink).replace("rankings?", "rankings?tac_accepted=" + (isChecked ? 'true' : 'false') + "&");
        $submitButton.attr("href", new_link);
    }).on('click', DOM.SUBMIT_BUTTON, function (evt) {
        var isChecked = $(DOM.TAC_CHECKBOX).is(":checked");

        $(DOM.TAC_DENIAL).toggleClass("invisible", isChecked);

        if (!isChecked) { evt.preventDefault(); }
    });
});
